<template>
  <div>
    <van-dialog v-model="accountIdVisible" title="账户ID管理" width="95%" style="height:80%" class="verifyClue" :beforeClose="beforeClose" :showConfirmButton='false' :close-on-click-overlay="true">
      <div class="content" style="padding-left:80px;text-indent:-80px;" v-if="bindForm.execCustomerId">
        <span class="key">执行客户：</span>
        <span class="value">{{ bindForm.execCustomerName }}</span>
      </div>
      <div class="content" style="padding-left:80px;text-indent:-80px;">
        <span class="key">项目名称：</span>
        <span class="value">{{ bindForm.projectName }}</span>
      </div>
      <div class="tagTitle">
        <van-tag type="success">账户ID列表</van-tag>
        <!-- <van-button type="info" native-type="button" size="mini" @click="addAuthId">新增账户ID</van-button> -->
        <van-icon name="add-o" size="30" color="#07c160" @click.stop="addAuthId" style="margin-right: 20px;" />
      </div>
      <van-search v-model="queryParams.accountId" placeholder="请输入账户ID进行搜索" @search="queryCustList" />
      <div style="padding: 5px; overflow: scroll; height: 66%" v-if="accountIdList.length > 0">
        <van-list v-model="loading" :finished="finished"  finished-text="没有更多了" @load="getList">
          <total-component :totalValue="total" />
          <van-cell v-for="(item,index) in accountIdList" :key="index">
            <div class="flex-between" v-if="item" style="align-items: flex-start">
              <div class="contract_detail">
                <div class="item">
                  <span class="key">账户ID：</span>
                  <span class="value">{{ item.accountId }}</span>
                </div>
                <!-- <div class="item">
                  <span class="key">账户类型：</span>
                  <span class="value">{{ item.consumeType == 1? '常规户' : '授权户' }}</span>
                </div> -->
                <div class="item">
                  <span class="key">平台：</span>
                  <span class="value">
                    <span v-if="item.accountType == 1">腾讯</span>
                    <span v-if="item.accountType == 2">巨量</span>
                    <span v-if="item.accountType == 3">百度</span>
                    <span v-if="item.accountType == 4">B站</span>
                    <span v-if="item.accountType == 5">京东</span>
                    <span v-if="item.accountType == 6">快手</span>
                  </span>
                </div>
                <div class="item">
                  <span class="key">子平台：</span>
                  <span class="value">{{ item.accountSubType }}</span>
                </div>
                <div class="item" v-if="item.cycle.length > 0">
                  <span class="key">周期：</span>
                  <span class="value">{{ item.cycle.join(',') }}</span>
                </div>
                <div class="item">
                  <span class="key">创建人：</span>
                  <span class="value">{{ item.createBy }}</span>
                </div>
              </div>
              <!-- <van-icon name="delete-o" size="30" color="#ee0a24" @click.stop="delAuthId(item)" style="margin-top: 36px;" /> -->
              <!-- <div>
                <van-button size="small" color="#ee0a24" @click="delAuthId(item)" style="border-radius: 5px;">删除</van-button>
              </div> -->
            </div>
            <div class="btns">
              <!-- <van-button type="info" size="mini" @click="handleProjectPoint(item)">返点</van-button> -->
              <!-- <van-button type="warning" size="mini" @click="updateAuthId(item)">修改</van-button> -->
              <van-button size="mini" color="#ee0a24" @click="delAuthId(item)" v-hasPermi="['cont:accountIdList:delete']">删除</van-button>
              <!-- <van-button type="primary" size="mini" @click="handleAccountID(item)">账户ID</van-button> -->
            </div>
          </van-cell>
        </van-list>
      </div>
    </van-dialog>
    <!-- 绑定账户ID -->
    <van-dialog v-model="bindVisible" title="新增账户ID" width="95%" style="height:70%" class="authId_dialog" :beforeClose="bindBeforeClose" show-cancel-button>
      <!-- <div class="tagTitle">
        <van-tag type="success">项目信息</van-tag>
      </div>
      <div class="card" style="min-height: 100px;margin: 0; padding: 0;">
        <div class="list-wrap van-hairline--top">
          <div class="item" style="padding-left:70px;text-indent:-70px;" v-if="bindForm.execCustomerId">
            <span class="key">执行客户：</span>
            <span class="value">{{ bindForm.execCustomerName }}</span>
          </div>
          <div class="item" style="padding-left:70px;text-indent:-70px;">
            <span class="key">项目名称：</span>
            <span class="value">{{ bindForm.projectName }}</span>
          </div>
        </div>
      </div>
      <div class="tagTitle">
        <van-tag type="success">新增账户ID</van-tag>
      </div> -->
      <van-form ref="bindForm" validate-trigger="onSubmit" class="dialog-form-wrap" style="height:98%;">
        <van-cell v-if="bindForm.isEdit == 1" title="账户ID" :border="false" :value="bindForm.accountIds"></van-cell>
        <van-field v-model="bindForm.startDateStr" readonly clickable name="calendar" label="投放开始时间" placeholder="点击选择投放开始时间" @click="showCalendar('startDateStr')" :rules="[{ required: true }]" required />
        <van-field v-model="bindForm.endDateStr" readonly clickable name="calendar" label="投放结束时间" placeholder="点击选择投放结束时间" @click="showCalendar('endDateStr')" :rules="[{ required: true }]" required />
        <van-cell title="是否授权户" required>
          <template>
            <van-radio-group v-model="bindForm.consumeType" direction="horizontal">
              <van-radio :name="1" clickable>常规户</van-radio>
              <van-radio :name="2" clickable>授权户</van-radio>
            </van-radio-group>
          </template>
        </van-cell>
        <template v-if="bindForm.isEdit != 1">
          <van-cell title="账户ID" required :border="false"></van-cell>
          <van-field v-model="bindForm.accountIds" rows="3" clearable type="textarea" placeholder="账户ID：多个账户ID用逗号隔开" style="border: 1px solid #d4d4d4; border-radius: 5px" :rules="[{ required: true }]" />
          <van-button style="margin-top: 5px;" type="warning" size="small" plain @click="handleTransfer" v-hasPermi="['cont:accountIdList:transfer']">一键转移</van-button>
          <van-cell style="color: #ff976a;" title="提示：账户ID发生冲突时，可点击（一键转移），；账户ID转其它项目时，账户ID余额为0时才可以换绑" v-hasPermi="['cont:accountIdList:transfer']" />
        </template>
      </van-form>
    </van-dialog>
    <van-dialog v-model="bindResultVisible" title="绑定结果" width="95%" style="height:80%" class="editClue" :close-on-click-overlay="true" show-cancel-button>
      <p style="overflow: scroll;height: 98%;" v-html="bindResult.failureMsg"></p>
      <van-cell v-if="bindResult.newItem" style="color: #ff976a;" title="提示：账户ID发生冲突时，可点击（一键转移），将冲突ID的截止时间改为昨天；账户ID转其它项目时，账户ID余额为0时才可以换绑" v-hasPermi="['cont:accountIdList:transfer']" />
      <div class="footer">
        <van-button hairline type="defaut" plain @click="bindResultVisible = false">确定</van-button>
        <van-button v-if="bindResult.newItem" hairline type="warning" plain @click="resultTransfer" v-hasPermi="['cont:accountIdList:transfer']">一键转移</van-button>
      </div>
    </van-dialog>

    <van-calendar v-model="datePicker.showDate" :min-date="datePicker.minDate" :max-date="datePicker.maxDate" :type="datePicker.type" @confirm="dateConfirm" />
  </div>
</template>

<script>
import payment from '@/api/cont/payment'
import { Toast, Dialog, ImagePreview } from 'vant'
import TotalComponent from '@/components/common/Total'
export default {
  components: {
    // Empty,
    TotalComponent,
    [Toast.name]: Toast,
    [Dialog.Component.name]: Dialog.Component,
    [ImagePreview.Component.name]: ImagePreview.Component
  },
  data() {
    return {
      accountIdVisible: false,
      showSearch: true,
      loading: false,
      finished: false,
      total: 0,
      queryParams: {
        pageNum: 1,
        pageSize: 10,
        projectId: null,
        accountId: null
      },
      accountIdList: [],
      bindVisible: false,
      datePicker: {
        showDate: false,
        minDate: new Date(2022, 0, 1),
        maxDate: new Date(2066, 12, 12),
        type: 'single',
        formKey: ''
      },
      bindForm: {
        accountType: null,
        startDateStr: null,
        endDateStr: null,
        accountIds: null,
        execCustomerId: null,
        execCustomerName: null,
        projectId: null,
        projectName: null,
        dataType: null,
        consumeType: 1
      },
      bindResultVisible: false,
      bindResult: {}
    }
  },
  async created() {
    await this.getOptions()
  },
  methods: {
    // 账户ID管理
    async handleAccountID(obj, type) {
      this.queryParams.projectId = obj.projectId
      this.bindForm.contractId = obj.contractId
      this.bindForm.execCustomerId = obj.execCustomerId
      this.bindForm.execCustomerName = obj.execCustomerName
      this.bindForm.projectId = obj.projectId
      this.bindForm.projectName = obj.projectName
      this.bindForm.startDateStr = this.getNextDate(0)
      this.bindForm.endDateStr = obj.endDateStr
      this.bindForm.dataType = obj.dataType
      if (type === 'direct') {
        this.bindVisible = true
      } else if (type === 'list') {
        await this.queryCustList()
        this.accountIdVisible = true
      }
    },
    // date 代表指定的日期，格式：2023-09-27
    // day 传-1表始前一天，传1表始后一天
    getNextDate(day) {
      var dd = new Date()
      dd.setDate(dd.getDate() + day)
      var y = dd.getFullYear()
      var m = dd.getMonth() + 1 < 10 ? '0' + (dd.getMonth() + 1) : dd.getMonth() + 1
      var d = dd.getDate() < 10 ? '0' + dd.getDate() : dd.getDate()
      return y + '-' + m + '-' + d
    },
    // 获取列表
    async getList() {
      await payment.listGroupAccountId(this.queryParams).then(res => {
        if (res.code === 200) {
          // this.accountIdList = res.data
          this.loading = true
          this.accountIdList = this.accountIdList.concat(...res.data.rows)
          this.queryParams.pageNum += 1
          this.total = res.data.total
          this.finished = this.accountIdList.length >= res.data.total
          this.loading = false
        }
      })
    },
    queryCustList() {
      this.accountIdList = []
      this.queryParams.pageNum = 1
      this.queryParams.pageSize = 10
      this.getList()
    },
    addAuthId() {
      this.bindForm.accountIds = null
      this.bindForm.isEdit = null
      this.bindVisible = true
    },
    updateAuthId(row) {
      this.bindForm.accountIds = row.accountId
      this.bindForm.accountSubType = row.accountSubType
      this.bindForm.accountType = row.accountType
      this.bindForm.consumeType = row.consumeType
      this.bindForm.projectId = row.projectId
      this.bindForm.projectName = row.projectName
      this.bindForm.isEdit = 1
      this.bindForm.startDateStr = row.cycle[0].split('~')[0]
      this.bindForm.endDateStr = row.cycle[0].split('~')[1]
      this.bindVisible = true
    },
    delAuthId(row) {
      const that = this
      Dialog.confirm({
        message: '是否确认删除当前账户ID“' + row.accountId + '”？'
      })
        .then(() => {
          payment.deleteByAccountId({ accountId: row.accountId, projectId: that.bindForm.projectId }).then(res => {
            if (res.code === 200) {
              Toast.success('删除成功')
              setTimeout(() => {
                that.queryCustList()
              }, 500)
            } else {
              Toast.fail(res.msg)
            }
          })
        })
        .catch(() => {
        // on cancel
        })
    },
    beforeClose(type, done) {
      this.$parent.getAuthIds(this.bindForm.projectId)
      done()
    },
    showCalendar(type) {
      this.datePicker.formKey = type
      this.datePicker.type = 'single'
      this.datePicker.showDate = true
    },
    dateConfirm(date) {
      // this.minDate = date
      this.bindForm[this.datePicker.formKey] = this.formatDate(date)
      this.datePicker.showDate = false
    },
    formatDate(date) {
      // 时间格式化 2019-09-08
      const year = date.getFullYear()
      const month = date.getMonth() + 1
      const day = date.getDate()
      return year + '-' + month + '-' + day
    },
    // 绑定账户ID
    async bindBeforeClose(type, done) {
      if (type === 'confirm') {
        try {
          await this.$refs.bindForm.validate()
          this.bindForm.isTransfer = null
          const res = await payment.addAssociationFront(this.bindForm)
          if (res.code === 200) {
            if (res.data.prompt) {
              Dialog.confirm({
                confirmButtonText: '继续',
                message: '<span style="color: #E6A23C;">提示（注：绑错合同并充值的，依据制度经办人成长200元/笔，请认真核查。）</span>\n' + res.data.prompt
              })
                .then(async () => {
                  await this.addAssociation(res.data.association)
                  done()
                })
            } else {
              await this.addAssociation(res.data.association)
              done()
            }
          }
        } catch (err) {
          return done(false)
        }
        return done(false)
      } else {
        return done()
      }
    },
    async addAssociation(data) {
      await payment.addAssociation(data).then(response => {
        if (response.code === 200) {
          Toast.success(response.msg)
          this.bindResult = response.data
          this.bindResultVisible = true
          this.bindVisible = false
          this.queryCustList()
          this.$parent.getAuthIds(this.bindForm.projectId)
        } else {
          Toast.fail(response.msg)
        }
      })
    },
    // 一键转移
    async handleTransfer() {
      await this.$refs.bindForm.validate()
      this.bindForm.isTransfer = 1
      const res = await payment.addAssociationFront(this.bindForm)
      if (res.code === 200) {
        if (res.data.prompt) {
          Dialog.confirm({
            confirmButtonText: '继续',
            message: '<span style="color: #E6A23C;">提示（注：绑错合同并充值的，依据制度经办人成长200元/笔，请认真核查。）</span>\n' + res.data.prompt
          })
            .then(async () => {
              await this.handleAssociation(res.data.association)
            })
        } else {
          await this.handleAssociation(res.data.association)
        }
      }
    },
    handleAssociation(data) {
      payment.addAssociation(data).then(response => {
        if (response.code === 200) {
          Toast.success(response.msg)
          this.bindResult = response.data
          this.bindResultVisible = true
          this.bindVisible = false
          this.queryCustList()
        } else {
          Toast.fail(response.msg)
        }
      })
    },
    async resultTransfer() {
      const res = await payment.addAssociationFront(this.bindResult.newItem)
      if (res.code === 200) {
        if (res.data.prompt) {
          Dialog.confirm({
            confirmButtonText: '继续',
            message: '<span style="color: #E6A23C;">提示（注：绑错合同并充值的，依据制度经办人成长200元/笔，请认真核查。）</span>\n' + res.data.prompt
          })
            .then(async () => {
              await this.transferAssociation(res.data.association)
            })
        } else {
          await this.transferAssociation(res.data.association)
        }
      }
    },
    transferAssociation(data) {
      payment.addAssociation(data).then(response => {
        if (response.code === 200) {
          Toast.success(response.msg)
          this.bindResultVisible = false
          this.queryCustList()
        } else {
          Toast.fail(response.msg)
        }
      })
    },
    getOptions() {

    }
  }
}
</script>

<style lang="less" scoped>
@import url("@/style/index.less");

/deep/.van-dialog__confirm{
  color: #ee0a24;
  border-top: 0.01333rem solid #ccc;
}
.verifyClue /deep/.van-dialog__content {
  height: 80%;
}
.editClue /deep/.van-dialog__content {
  height: 67%;
}
.editClue /deep/.van-dialog__footer{
  display: none;
}
.content{
  width: 76%;
  margin: 0 auto;
  font-size: 28px;
  padding: 20px 0;
  background-color: #C6E2FF;
  border-radius: 10px;
  margin-top: 10px;
  .key{
    margin-left: 20px;
  }
}
.authId_dialog /deep/.van-dialog__content {
  height: 78%;
}
.media /deep/.van-dialog__content {
  height: 65%;
}
.van-cell__value {
  min-width: 67%; // 可根据自己需求设定值
  text-align: left;
}
/deep/.van-list{
  padding: 0;
}
.tagTitle{
  padding: 0 10px;
  margin-top: 16px;
  display: flex;
  justify-content: space-between;
}
.authId_topBtn{
  width: 80%;
  margin: 20px auto;
}

.btns{
  display: flex;
  justify-content: center;
  .van-button {
    width: 20%;
    border-radius: 10px;
  }
}

.footer{
  display: flex;
  margin-top: -10px;
  .van-button{
    width: 50%;
    border: 1px #f4f4f4 solid;
  }
}
</style>
